export enum PrivacySettingsActionTypes {
  ACCEPT = '[Privacy Settings] Accept Cookies',
  REJECT = '[Privacy Settings] Reject Cookies',
}

export class PrivacySettingsAcceptAction {
  public readonly type = PrivacySettingsActionTypes.ACCEPT;
}

export class PrivacySettingsRejectAction {
  public readonly type = PrivacySettingsActionTypes.REJECT;
}

export type PrivacySettingsActionsUnion = PrivacySettingsAcceptAction | PrivacySettingsRejectAction;
